// Eskom PARCC — person chip (owner R3 feedback 1): an assignee/reviewer shown as
// an initials avatar + resolved name ("Lindiwe T."), with the raw email kept as a
// hover title. Resolution + formatting live in lib/people; this is the presentation.
import { normalizeEmail } from '../../lib/email';
import { formatPersonName, initialsOf, type NameDirectory } from '../../lib/people';

export function PersonChip({
  email,
  directory,
  showAvatar = true,
}: {
  email: string | null | undefined;
  directory: NameDirectory;
  showAvatar?: boolean;
}): React.JSX.Element {
  const key = normalizeEmail(email);
  if (!key) return <span className="person-chip">—</span>;
  const entry = directory.get(key) ?? { email: key };
  return (
    <span className="person-chip" title={key}>
      {showAvatar && <span className="person-avatar">{initialsOf(entry)}</span>}
      {formatPersonName(entry)}
    </span>
  );
}
